import { VideoEmbedComponent } from './video-embed.component'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { SharedModule } from '../shared/shared.module'
import { MetaGuard } from 'meta'

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: '',
        canActivate: [MetaGuard],
        component: VideoEmbedComponent,
        data: {
          hideHeader: true,
          hideFooter: true,
          shouldShowEventTicker: false
        }
      }
    ])
  ],
  exports: [RouterModule]
})
export class VideoEmbedRoutingModule {}
